import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainNav from './MainNav';
import { jwtDecode } from 'jwt-decode';
import { useUser } from '../../UserContext';
import { signOut } from 'aws-amplify/auth';


const Authenticating = () => {
    const navigate = useNavigate();
    const { isSignedIn, setIsSignedIn } = useUser();

    async function extractTokens() {
        const currentUrl = window.location.href;

        const extractTokens = (url) => {
            const params = new URLSearchParams(url.split('#')[1]);
            const accessToken = params.get('access_token');
            const idToken = params.get('id_token');
            return { accessToken, idToken };
        }

        const { accessToken, idToken } = extractTokens(currentUrl);

        if (!accessToken || !idToken) {
            console.warn('Access token or ID token not found in the URL.');
            navigate('/');
            return;
        }

        sessionStorage.setItem('accessToken', accessToken);
        sessionStorage.setItem('idToken', idToken);

        //Let's logout the vendor too, if they are signed in.
        try {
            await signOut();
            setIsSignedIn(false);
        } catch (error) {
        }

        try {
            // Decode the idToken
            const decodedToken = jwtDecode(idToken);
            const email = decodedToken.email;
            const first_name = decodedToken.first_name;
            const last_name = decodedToken.last_name;
            sessionStorage.setItem('email', email);
            sessionStorage.setItem('first_name', first_name);
            sessionStorage.setItem('last_name', last_name);

            // Set up token expiration check
            setTokenExpiryHandler(decodedToken.exp);

        } catch (error) {
            console.error('Error decoding token:', error);
        }

        const token = sessionStorage.getItem('accessToken');

        if (!sessionStorage.getItem('addons')) {
            getAddOns();
        }
        if (!sessionStorage.getItem('pm')) {
            getPM();
        }
        navigate('/');
    }

    useEffect(() => {
        extractTokens();
    }, []);


    function setTokenExpiryHandler(expiry) {
        const expirationTime = expiry * 1000; // Convert expiry to milliseconds
        const currentTime = Date.now();
        if (expirationTime <= currentTime) {
            // Token already expired, logout immediately
            handleAutoLogout();
        } else {
            // Set timeout to log out the user just before the token expires
            setTimeout(handleAutoLogout, expirationTime - currentTime);
        }
    }

    async function handleAutoLogout() {
        console.warn('Token expired, logging out...');
        try {
            await signOut();
            setIsSignedIn(false);
            sessionStorage.clear();
            navigate('/'); // Redirect to login page
        } catch (error) {
            console.error('Error during auto logout:', error);
        }
    }


    async function getAddOns() {
        try {
            let response = await fetch("https://ehr2.charmtracker.com/api/ehr/v1/addons/ehr", {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let data = await response.json();
            sessionStorage.setItem('addons', JSON.stringify(data));
            return data;
        } catch (error) {
            console.error('Error fetching status:', error);
            return null;
        }
    }
    async function getPM() {
        try {
            let response = await fetch("https://ehr2.charmtracker.com/api/ehr/v1/addons/pm", {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let data = await response.json();
            sessionStorage.setItem('pm', JSON.stringify(data));
            return data;
        } catch (error) {
            console.error('Error fetching status:', error);
            return null;
        }
    }

    return (
        <div className='h-full w-full flex-col'>
            <MainNav navbarColor={"#26051C"} />
            <h1 className='text-2xl font-bold'>Authenticating</h1>
        </div>
    );
}

export default Authenticating;